import { createContext, useContext, useEffect, useState } from 'react';
import { signInWithCustomToken, signInWithPopup, onAuthStateChanged, signOut, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../config/firebase';
import { getStorageValue, useLocalStorage } from './local-storage-context';
import { createSession } from '../services/sandbox-api.service';

export const authContext = createContext();
const provider = new GoogleAuthProvider();

export const useAuth = () => {
    const context = useContext(authContext);
    if (!context) {
        throw new Error('There is not auth provider');
    }
    return context;
};

export function AuthContext({ children }) {

    const [user, setUser] = useState();
    const [loggedIn, setLoggedIn] = useLocalStorage('loggedIn', false);


    const login = async () => {
        try {
            const { user } = await signInWithPopup(auth, provider);
            if (!user) {
                return;
            }
            const idToken = await user.getIdToken();
            const response = await createSession(idToken);
            const customToken = response.data['customToken']
            await signOut(auth);
            setLoggedIn(true);
            await signInWithCustomToken(auth, customToken);
        } catch (e) {
            console.error(e);
        }
    }

    const logOut = async () => {
        await signOut(auth);
        setLoggedIn(false);
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            const logged = getStorageValue('loggedIn');
            if (user && logged) {
                setUser(user);
            } else {
                setUser(null);
            }
        });
    }, []);

    return (
        <authContext.Provider value={{ login, logOut, user }}>
            {children}
        </authContext.Provider>
    );
}
